/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type GenerateImageUploadUrlCommand = {
    entityId?: string;
    entityType?: GenerateImageUploadUrlCommand.entityType;
    imageType?: GenerateImageUploadUrlCommand.imageType;
};
export namespace GenerateImageUploadUrlCommand {
    export enum entityType {
        SHOP = 'SHOP',
        FINANCIER = 'FINANCIER',
    }
    export enum imageType {
        BODY = 'BODY',
        WITH_IMEI_OR_SN = 'WITH_IMEI_OR_SN',
        WITH_SETTINGS_SCREEN = 'WITH_SETTINGS_SCREEN',
    }
}

